export default "__VITE_ASSET__DDNLgsTO__"